import React from "react";
import CreateEditUser from "./CreateEditUser";

const EditUser = ()=>{

    return (
        <CreateEditUser />
    )
}

export default EditUser;